import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { clearLeadCreation } from 'store/CreditScoreState';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch } from 'react-redux';
import { MODULE_NAME } from 'pages/digitalRetailing/DigitalRetailingConstant';
import { DIGITAL_RETAILING_MODAL_CLOSE } from 'constants/CommonConstants';

interface PreApprovedHeaderProps {
  currentStep?: number;
}

const PreApprovedHeader: React.FC<PreApprovedHeaderProps> = ({ currentStep = 0 }) => {
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const onCloseModal = () => {
    window.parent.postMessage(
      { type: DIGITAL_RETAILING_MODAL_CLOSE, data: { close: true }, res: { module: 'digital-retailing' } },
      '*'
    );
    dispatch(clearLeadCreation());
    localStorage.setItem(`${MODULE_NAME}-currentStep`, '0');
    localStorage.removeItem(MODULE_NAME);
  };

  const steps = ['Personal Information', 'Employment Options', 'Summary'];

  return (
    <div className='dr-header'>
      <ul className='wizard-step list-unstyled with-tb-space hide-scrollbar'>
        {steps.map((step, index) => (
          <li key={index} className={index <= currentStep ? 'current' : ''}>
            {step}
          </li>
        ))}
      </ul>
      <button type='button' className='btn-close' onClick={onCloseModal}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default PreApprovedHeader;
